export default "__VITE_PUBLIC_ASSET__589552b7__"